module.exports = __webpack_public_path__ + "media/images/pic/tree-bf8bd07f4177e1d7fbd56a9cfda5b47c.webp";